import md5 from 'md5-jkmyers';
import referrer from './referrer';

/**
 * Generate a unique session id
 *
 * @return {String}
 */
export default function sid () {
  return md5(window.navigator.userAgent + referrer() + Date.now() + Math.random());
}
